import { render, staticRenderFns } from "./serviceRevenue.vue?vue&type=template&id=2943efa8&scoped=true&"
import script from "./serviceRevenue.vue?vue&type=script&lang=js&"
export * from "./serviceRevenue.vue?vue&type=script&lang=js&"
import style0 from "./serviceRevenue.vue?vue&type=style&index=0&id=2943efa8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2943efa8",
  null
  
)

export default component.exports